module.exports = __webpack_public_path__ + "media/images/like_animation-96567dcb7e7bbfba15dc4f39877abb70.png";